import { IS_BIZ_USER } from 'reactApp/appHelpers/configHelpers';

export const VIEW_MODE_THUMBS_TEXT = IS_BIZ_USER ? 'Плиткой' : 'Таблицей';
